import React from 'react';

const buttonStyle: React.CSSProperties = {
    border: '1px solid #ccc',
    backgroundColor: '#f9f9f9',
    color: '#333',
    width: 30,
    height: 30,
    cursor: 'pointer',
    userSelect: 'none',
    fontSize: 17,
    lineHeight: 1,
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 2,
    margin: '0 2px',
};

const inputStyle: React.CSSProperties = {
    width: 100,
    height: 30,
    textAlign: 'center' as const,
    fontSize: 16,
    border: '1px solid #ccc',
    borderRadius: 2,
    outline: 'none',
};

const QuantityInput = ({
    quantity,
    minQuantity,
    onChange,
}: {
    quantity: number;
    minQuantity: number;
    onChange: (newQuantity: number) => void;
}) => {
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = Number(e.target.value);
        if (!isNaN(val)) {
            onChange(val);
        }
    };

    const increment = () => onChange(quantity + 1);

    const decrement = () => {
        onChange(quantity - 1);
    };

    return (
        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
            <button type="button" style={buttonStyle} onClick={decrement} aria-label="decrement">
                <span style={{ height: 20 }}>-</span>
            </button>
            <input
                value={quantity}
                min={minQuantity}
                onChange={handleInputChange}
                style={inputStyle}
                aria-label="quantity input"
            />
            <button type="button" style={buttonStyle} onClick={increment} aria-label="increment">
                <span style={{ height: 20 }}>+</span>
            </button>
        </div>
    );
};

export default QuantityInput;
